export class DepartmentDivision {
    $id: string;
    DepartmentDivisionID: string;
    Name: string;
    DepartmentID: string;
    MaxPictureSize: number;
    CreatedDate: Date;
    CreatedByUserId?: any;

    public constructor(init?: Partial<DepartmentDivision>) {
        Object.assign(this, init);
    }
}
